import React from "react";
import KLProgressBar from "../KLProgressBar";

type KLCustomerBookingProgressProps = {
  currentStep: number;
};

const customerLabels = ["מה בא לכם", "מתי בא לכם", "קבענו לי!"];

const KLCustomerBookingProgress: React.FC<KLCustomerBookingProgressProps> = ({
  currentStep,
}) => (
  <KLProgressBar
    currentStep={currentStep}
    totalSteps={customerLabels.length}
    labels={customerLabels}
  />
);

export default KLCustomerBookingProgress;
